<template>
    <v-container fluid class="pa-0">
        <v-card>
            <v-card-title primary-title>
                <v-row>
                    <v-col>Request Protocols</v-col>
                    <v-spacer />
                    <v-col class="text-right">
                        <v-btn color="primary" @click="handleCreateRequestProtocol"
                            >New Protocol</v-btn
                        >
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <RequestProtocolsList
                    :requestProtocols="requestProtocols"
                    :requestProcessors="requestProcessors"
                    :containerTypes="containerTypes"
                    :search="props.search"
                    @editRequestProtocol="handleEditRequestProtocol"
                />
            </v-card-text>
        </v-card>
        <v-dialog v-model="requestProtocolDialogVisible" max-width="600px">
            <RequestProtocolForm
                :existingProtocol="selectedProtocol"
                :requestProcessors="requestProcessors"
                :containerTypes="containerTypes"
                @canceled="requestProtocolDialogVisible = false"
                @requestProtocolSaved="handleRequestProtocolSaved"
            />
        </v-dialog>
    </v-container>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { withLoadingScreen } from "@/lib/loading.js";
import { RequestProcessor, samplesAPI, SavedRequestProtocol } from "@/services/samples/samplesAPI";
import RequestProtocolsList from "@/components/SamplesV2/RequestProtocolsList.vue";
import { ContainerType } from "@/services/commonModels";
import RequestProtocolForm from "@/components/SamplesV2/RequestProtocolForm.vue";

interface Props {
    search: string
}

const props = withDefaults(defineProps<Props>(), {
    search: "",
});

const requestProtocols = ref<SavedRequestProtocol[]>([]);
const requestProtocolDialogVisible = ref(false);
const selectedProtocol = ref<SavedRequestProtocol | undefined>(undefined);
const requestProcessors = ref<RequestProcessor[]>([]);
const containerTypes = ref<ContainerType[]>([]);

async function reloadRequestProtocols() {
    await withLoadingScreen(async () => {
        requestProtocols.value = await samplesAPI.fetchRequestProtocols();
    });
}

onMounted(async () => {
    await reloadRequestProtocols();
    requestProcessors.value = await samplesAPI.fetchRequestProcessors();
    containerTypes.value = await samplesAPI.fetchRequestContainerTypes();
});

function handleCreateRequestProtocol() {
    selectedProtocol.value = undefined;
    requestProtocolDialogVisible.value = true;
}

function handleEditRequestProtocol(protocol: SavedRequestProtocol) {
    selectedProtocol.value = protocol;
    requestProtocolDialogVisible.value = true;
}

async function handleRequestProtocolSaved() {
    requestProtocolDialogVisible.value = false;
    selectedProtocol.value = undefined;
    await reloadRequestProtocols();
}

</script>
